import clsx from "clsx";

export const getSelectionInfoClassNames = ({
  isSelected,
}: {
  isSelected?: boolean;
}) => {
  const baseStyles =
    "flex flex-col items-start gap-small rounded p-[1.6rem] bg-cyan-40 border-l-4 border-blue-660";
  const selectedStyles = "bg-green-100 border-green-800";

  return clsx(baseStyles, isSelected && selectedStyles);
};
